import React from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { useState } from "react";
import { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDate } from "../../constants/DateUtil/DateUtil";
import { DataView } from "primereact/dataview";
import { getWarehouseGarmentsByStatus } from "../../services/warehouse/WarehouseProcess";
import WarehouseStatusFilterModal from "./WarehouseStatusFilterModal";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

const WarehouseQrCodeList = () => {
  const navigate = useNavigate();

  const { brandProfileData, warehouseData } = getUserData();

  let warehouseId = warehouseData.id;
  let enabledGarmentInspection = brandProfileData.enabledGarmentInspection;

  const statusList = ["IN_PROCESS", "PROCESSED", "UNPROCESSED"];

  const [searchText, setSearchText] = useState("");


  const [qrCodeData, setQrCodeData] = useState([]);
  const [qrCodeStatusFilterModalVisible, setQrCodeStatusFilterModalVisible] =
    useState(false);

  const [selectedStatus, setSelectedStatus] = useState(['IN_PROCESS']); // Default to show all orders
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]); // Default to show all orders
  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
    const data = {
      status: selectedStatus,
    };
    fetchQrCodeList(data);
    setUpDateSelectedStatus([]);
  };


  const handleCalendarModal = () => {
    setQrCodeStatusFilterModalVisible(true);
  };


  const fetchQrCodeList = (data) => {
    getWarehouseGarmentsByStatus(warehouseId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setQrCodeData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      status: ["IN_PROCESS"],
    };
    fetchQrCodeList(data);
    setUpDateSelectedStatus([]);
  }, []);

  const handleChallanQrCodeProcess = (item) => {
    navigate("/WarehouseOrderProcess", {
      state: {
        qrCode: item,
      }
    });
  };

  const filteredQrCodeData = qrCodeData.filter((item) => {
    const billNo = item.qrCode?.match(/.*(?=OI)/)?.[0] || "";

    return (
      item.qrCode?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.garmentName?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.status?.toLowerCase().includes(searchText.toLowerCase()) ||
      billNo.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const wareHouseStatusColor = {
    DEFAULT: "#3EB3E1",
  };

  const itemTemplate = (order, index) => {
    const orderStatusColor =
      wareHouseStatusColor[order.status] || wareHouseStatusColor.DEFAULT;
    const deliveryOn = formatDate(order.deliveryOn);
    const str = order.qrCode;
    const billNo = str.match(/.*(?=OI)/)[0];
    return (
      <Accordion>
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": orderStatusColor,
            fontSize: 10,
          }}
          header={`${index + 1} | ${order.qrCode} ${order?.garmentPack ? " | " + order.garmentPack : ""}`}
        >
          <div className="cursor-pointer">
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Garment Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {order.garmentName.replace(/_/g, " ")}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Status:</p>
                <p className="text-lg font-bold capitalize">
                  {order.status.replace(/_/g, " ")}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Bill No.:</p>
                <p className="text-lg font-bold capitalize">{billNo}</p>
              </div>
            </div>

            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Delivery On: :
                </p>
                <p className="text-lg font-bold capitalize">{deliveryOn}</p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Re Process :
                </p>
                <p className="text-lg font-bold capitalize">
                  {!order.reProcess ? (
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                      }
                      style={{
                        width: 20,
                      }}
                    />
                  ) : (
                    <img
                      src={
                        "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                      }
                      style={{
                        alignSelf: "center",

                        width: 20,
                      }}
                    />
                  )}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Garment Image:
                </p>
                <p className="text-lg font-bold capitalize">
                  {enabledGarmentInspection && (
                    <div className="ml-5 cursor-pointer">
                      <i
                        className="pi pi-image"
                        onClick={() =>
                          navigate("/WarehouseGarmentInspectionImages", {
                            state: {
                              QrCodeInfo: order,
                            },
                          })
                        }
                        style={{
                          fontSize: "27px",
                          cursor: "pointer",
                          color: "#2B70D7",
                        }}
                      ></i>
                    </div>
                  )}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">Orders</p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-4 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>

          {selectedStatus.includes("IN_PROCESS") && (
            <div
              onClick={() => handleChallanQrCodeProcess(qrCodeData)}
              className="mx-2 cursor-pointer"
            >
              <img
                src={"Laundy_App_Icons_Gifs/Order_Statuses_icons/PROCESSED.png"}
                style={{ width: 27 }}
              />
            </div>
          )}
        </div>
      </div>

      <div className="mx-4 my-2">
        <div className=" mb-2 mx-4 flex flex-row justify-content-between">
          <div className=" flex flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"></InputIcon>
              <InputText
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                placeholder="Search QR Code, Garment, Status, Bill No..."
                showSoftInputOnFocus={false}
                autoFocus={true}
              />
            </IconField>
          </div>
          {searchText && (
            <div
              className="flex justify-content-end align-items-center cursor-pointer"
              onClick={() => setSearchText("")}
            >
              <p
                className="text-3xl font-bold ml-4"
                style={{ color: "red" }}
              >
                X
              </p>
            </div>
          )}
        </div>
        <div>
          {filteredQrCodeData.length > 0 ? (
            <DataView
              value={filteredQrCodeData}
              listTemplate={listTemplate}
              paginator
              rows={20}
            />
          ) : filteredQrCodeData.length === 0 ? (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">No Tag Found</p>
            </div>
          ) : (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">Tag List is Loading</p>
            </div>
          )}
        </div>

        <WarehouseStatusFilterModal
          setStatusFilterModalVisible={setQrCodeStatusFilterModalVisible}
          statusFilterModalVisible={qrCodeStatusFilterModalVisible}
          sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
          upDateSelectedStatus={upDateSelectedStatus}
          OrderStatus={statusList}
        />
      </div>
    </div>
  );
};

export default WarehouseQrCodeList;
